<template>
  <Modal :mask-closable="false" v-model="show" :title="title" :width="500">
    <table class="QHtable">
      <tr>
        <td style="width: 80px"><b>审核情况</b></td>
        <td>
          <RadioGroup v-model="form.govAuthStatus" size="small">
            <Radio label="100" border>待审</Radio>
            <Radio label="200" border>通过</Radio>
            <Radio label="300" border>拒绝</Radio>
          </RadioGroup>
        </td>
      </tr>
      <tr>
        <td style="width: 80px"><b>审核理由</b></td>
        <td><Input v-model="form.govAuthStatusNote" placeholder="请输入审核理由" maxlength="255" /></td>
      </tr>
    </table>
    <div slot="footer">
      <Button @click="clearFrom()">取消</Button>
      <Button type="primary" @click="saveOk">确定</Button>
    </div>
  </Modal>
</template>

<script>
import data from "./data.js";
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      title: "监管审核",
      show: false,
      api: "",
      form: { ...data.data },
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:确认提交
    // +----------------------------------------------------------------------
    saveOk() {
      //综合赋值验证
      var parameter = this.$isSubmitValidGetPram(this, data);
      if (!parameter) {
        return;
      }

      //参数整合与接口
      var that = this;
      var api = this.api;
      var https = {
        isLoading: "isLoadingPop",
        api: this.$api[api],
        parameter: parameter,
        successMsg: "保存成功",
      };

      //请求接口
      var title = "审核确认";
      var msg = "请再次确认审核情况，是否继续吗？";
      this.$confirm({ title: title, msg: msg }, function () {
        that.$httpsApi(https, function (res) {
          that.$emit("success");
          that.clearFrom();
        });
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:唤起新增
    // +----------------------------------------------------------------------
    hiPop(id, api) {
      this.clearFrom();
      this.api = api;
      this.form.id = id;
      this.show = true;
    },

    // +----------------------------------------------------------------------
    // | Desc:清理表单
    // +----------------------------------------------------------------------
    clearFrom() {
      this.show = false;
      this.api = "";
      this.form = { ...data.data };
    },
  },
};
</script>
